import { render, staticRenderFns } from "./SupportContactsManager.vue?vue&type=template&id=a36bba3e"
import script from "./SupportContactsManager.vue?vue&type=script&lang=js"
export * from "./SupportContactsManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports